import "antd/lib/card/style";
import _Card from "antd/lib/card";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs"; /*@客户-设备流量*/
import React from 'react';
import './index.scss';
import { parse } from "../../../utils/commonUtilFunc";
import { withRouter } from 'react-router-dom';
import { addComma } from "../../../utils/commonUtilFunc";
import FlowInfo from "./subComponents/FlowInfo";
import AppRank from "./subComponents/AppRank";
import UserFlowRank from "./subComponents/UserFlowRank";
import { injectIntl } from "react-intl";
var TabPane = _Tabs.TabPane;
var CI0304 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0304, _React$Component);
  function CI0304(props) {
    var _this;
    _classCallCheck(this, CI0304);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0304).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "switchTab", function (key) {
      if (key === '2' && _this.ref.get_step_apps) {
        _this.ref.get_step_apps();
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onRef", function (vm) {
      _this.ref = vm;
    });
    _this.state = {};
    _this.ref = {};
    return _this;
  }
  _createClass(CI0304, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      var search = parse(this.props.location.search);
      return /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
        className: "title-device-name"
      }, "Device Name", ":", parse(this.props.location.search).device_name), /*#__PURE__*/React.createElement("div", {
        className: "title-device-info"
      }, /*#__PURE__*/React.createElement("span", null, "time slot", ":\xA0\xA0", search.start_tm, "\xA0", "to", "\xA0", search.end_tm), /*#__PURE__*/React.createElement("span", null, "Traffic type", ":\xA0\xA0", search.tunnel_dir), /*#__PURE__*/React.createElement("span", null, "Traffic size", ":\xA0", addComma(search.flow), "\xA0\xA0MB"))), /*#__PURE__*/React.createElement(_Tabs, {
        onChange: this.switchTab
      }, /*#__PURE__*/React.createElement(TabPane, {
        tab: "Traffic Overview",
        key: "1"
      }, /*#__PURE__*/React.createElement(FlowInfo, null)), /*#__PURE__*/React.createElement(TabPane, {
        tab: "App leaderboard",
        key: "2"
      }, /*#__PURE__*/React.createElement(AppRank, {
        onRef: this.onRef
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "User leaderboard",
        key: "3"
      }, /*#__PURE__*/React.createElement(UserFlowRank, {
        flow: search.flow
      }))));
    }
  }]);
  return CI0304;
}(React.Component);
export default withRouter(injectIntl(CI0304));